var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTh = function SvgTh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001b9a",
    d: "M0 162.544h640v160.003H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e70000",
    d: "M0 .042h640v82.5H0zM0 400.003h640v80H0z"
  }))));
};
export default __webpack_public_path__ + "assets/194a8d8f31ff25cf75d0455a91facdc0.svg";
export { SvgTh as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/th.svg